// extracted by mini-css-extract-plugin
export default {"container":"Stage_container__jXb6a","spin":"Stage_spin__E0co5","spinner":"Stage_spinner__z-OaR"};